/**
 * @license Givaudan. All rights reserved
 * @author Ayoub MHAMDI
 */

import { RequestStatus } from '@banyan/commons/enum/request-status';

import { Fragrance } from '../models/fragrance.model';
import { QuoteProposal } from '../models/quote-proposal.model';
import { QuoteResponse } from '../models/quote-response.model';

export function fromCartResponseToCart(
  QuoteResponse: QuoteResponse
): QuoteProposal {
  const fragrances: Fragrance[] = [];

  if (QuoteResponse.products) {
    for (const product of QuoteResponse.products) {
      const fragrance: Fragrance = {
        id: product.id,
        name: product.name,
        keywords: product.keywords,
        description: product.description,
        essenses:
          product.customAttribute.find(attr => attr.name === 'essence')
            ?.value ?? [],
        powers:
          product.customAttribute.find(attr => attr.name === 'powers')?.value ??
          [],
        colors:
          product.customAttribute.find(attr => attr.name === 'color')?.value ??
          [],
        images: product.images ?? [],
        ingredients:
          product.customAttribute.find(attr => attr.name === 'ingredients')
            ?.value ?? [],
        variants: product.variants.map(variant => ({
          id: variant.id,
          sku: variant.sku,
          price: variant.price,
          type: variant.type,
          packaging: variant.packaging,
        })),
      };

      fragrances.push(fragrance);
    }
  }

  let statusCode;
  switch (QuoteResponse.statusCode) {
    case 5:
      statusCode = RequestStatus.expired;
      break;
    case 7:
      statusCode = RequestStatus.requestSubmitted;
      break;
    default:
      statusCode = RequestStatus.fragranceProposal;
      break;
  }

  return {
    quoteNumber: QuoteResponse.quoteNumber,
    statusCode: statusCode,
    createdAt: QuoteResponse.createdAt,
    expiredAt: QuoteResponse.expiredAt,
    captureNeedRecap: JSON.parse(QuoteResponse.notes),
    fragrances,
  };
}
